import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  link: {
    color: 'inherit'
  }
})

export default useStyles
